<!--CAROUSeL-->
<img [src]="showImg" class="d_principalconte d_imgsslide">
<!-- <span class="d_plecalogos">
    <img src="assets/redi/img/home_text.webp">
    <img [src]="home_avatar">
</span> -->
<app-buscador-general *ngIf="existenDatos" class="d_principalin" style="z-index: 1;" />

@if (listImg.length > 1) {
<div class="d_principalin">
    <div class="d_principalconteinfo">
        <div class="d_carouselbts">
            @for (item of listImg; track $index) {
            <div class="d_carouselbtn" (click)="viewImg($index+1)">
                @if ($index+1 === incCont) {
                <span style="display: block;"></span>
                }
            </div>
            }
        </div>
    </div>
</div>
}
